import React from "react";
import { Box } from "@mui/material";
import { useSnackbar } from "notistack";
import { useAssetBaseUrl } from "../../../hooks";
import ViewTransformationWODs from "./ViewTransformationWODs";
import { CreateTransformationWOD } from "./CreateTransformationWOD";
import { TransformationWOD } from "./types";

export const TransformationWODPage = () => {
  const [editingWod, setEditingWod] = React.useState<TransformationWOD>();
  const [refreshCounter, setRefreshCounter] = React.useState(0);
  const {
    baseUrl: assetBaseUrl,
    loading: assetLoading,
    error: assetError,
  } = useAssetBaseUrl();
  const { enqueueSnackbar } = useSnackbar();

  React.useEffect(() => {
    if (assetError) {
      enqueueSnackbar(
        "Failed to load image settings. Some images may not display.",
        { variant: "error" }
      );
    }
  }, [assetError, enqueueSnackbar]);

  const handleEditWod = (wod: TransformationWOD) => {
    setEditingWod(wod);
  };

  const clearEditingWod = () => {
    setEditingWod(undefined);
  };

  const handleDataChanged = () => {
    setRefreshCounter((prev) => prev + 1);
  };

  const handleSaved = () => {
    clearEditingWod();
    handleDataChanged();
  };

  return (
    <Box
      sx={{
        flexGrow: 1,
        p: { xs: 2, md: 3 },
        height: "100%",
        display: "flex",
        flexDirection: "column",
        overflow: "hidden",
      }}
    >
      <Box
        sx={{
          flex: 1,
          minHeight: 0,
          display: "flex",
          flexDirection: "column",
          gap: 2,
        }}
      >
        <CreateTransformationWOD
          editingWod={editingWod}
          refreshCounter={refreshCounter}
          assetBaseUrl={assetBaseUrl}
          onSaved={handleSaved}
          onCancelEdit={clearEditingWod}
        />
        <Box sx={{ flex: 1, minHeight: 0 }}>
          <ViewTransformationWODs
            onEditWodSelected={handleEditWod}
            onDataChanged={handleDataChanged}
            refreshCounter={refreshCounter}
            assetBaseUrl={assetBaseUrl}
            assetLoading={assetLoading}
          />
        </Box>
      </Box>
    </Box>
  );
};
